import React from "react";
import NFTTransactionsView2 from "./View";

const NFTTransactions2 = () => {
  return <NFTTransactionsView2 />;
};

export default NFTTransactions2;
